/*
  Dtcs state
*/
export default {
  loading: false,
  eventList: [],
  eventDictList: [],
  odometers: {
    today: [],
    yesterday: [],
    thisweek: [],
    lastweek: []
  }
}
